<template>
  <div class="sync-section" :class="$attrs.class">
    <div class="sync-section-header">
      <div>
        <h4 class="title is-6 mb-0">{{ title }} ({{ displayCount }})</h4>
        <p v-if="isTruncated" class="is-size-7 has-text-grey mb-0">
          Shfaqen {{ items.length }} nga {{ totalCount }} — shkarko Excel për listën e plotë
        </p>
      </div>
      <div v-if="canExport" class="sync-section-actions">
        <button type="button" class="button is-small is-light" :disabled="exporting" @click="$emit('export')">
          <i v-if="exporting" class="fa fa-spinner fa-spin mr-1"></i>
          <i v-else class="fa fa-file-excel-o mr-1"></i>
          Excel
        </button>
        <button type="button" class="button is-small is-light" @click="$emit('copy')">
          <i class="fa fa-copy mr-1"></i> Kopjo
        </button>
      </div>
    </div>
    <pre v-if="items.length" class="sync-code-block mt-2">{{ displayText }}</pre>
    <p v-else class="is-size-7 has-text-success mt-2">Asnjë problem në këtë kategori.</p>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    title: { type: String, required: true },
    items: { type: Array, default: () => [] },
    format: { type: String, default: "lines" },
    totalCount: { type: Number, default: null },
    exporting: { type: Boolean, default: false },
  },
  emits: ["copy", "export"],
  computed: {
    displayCount() {
      if (this.totalCount != null && this.totalCount > 0) return this.totalCount;
      return this.items.length;
    },
    isTruncated() {
      return this.totalCount != null && this.totalCount > this.items.length;
    },
    canExport() {
      return (this.totalCount != null && this.totalCount > 0) || this.items.length > 0;
    },
    displayText() {
      if (this.format === "products") {
        return this.items.map((p) => `${p.code || "—"}\t${p.name || ""}`).join("\n");
      }
      if (this.format === "attribute_issues") {
        return this.items
          .map((p) => {
            const missing = (p.missing || []).join(", ");
            const reason = p.reason ? ` (${p.reason})` : "";
            const tail = missing ? `\t→ ${missing}` : reason;
            return `${p.code || "—"}\t${p.name || ""}${tail}`;
          })
          .join("\n");
      }
      if (this.format === "web_categories") {
        return this.items
          .map((p) => {
            const eff = [p.effective_web_cat_1, p.effective_web_cat_2, p.effective_web_cat_3]
              .filter((v) => v != null && String(v).trim() !== "")
              .join(" > ");
            const stored = [p.stored_web_cat_1, p.stored_web_cat_2, p.stored_web_cat_3]
              .filter((v) => v != null && String(v).trim() !== "" && String(v).trim() !== "[Pa Percaktuar]")
              .join(" > ");
            return `${p.code || "—"}\t${p.name || ""}\tEfektive: ${eff || "—"}\tKolona produkt: ${stored || "—"}`;
          })
          .join("\n");
      }
      if (this.format === "duplicate_codes") {
        return this.items
          .map((p) => `${p.code || "—"}\t${p.name || ""}\t×${p.duplicate_count || 2}`)
          .join("\n");
      }
      return (this.items || []).join("\n");
    },
  },
};
</script>

<style scoped>
.sync-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.sync-section-actions {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}
.sync-code-block {
  max-height: 140px;
  overflow: auto;
  padding: 0.75rem;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
}
</style>
